import { Component, OnInit, Input } from '@angular/core';
import { InvoiceModel } from 'app/models/invoices.model';
import { Observable } from 'rxjs';

@Component({
  standalone: false,
  selector: 'nexus-invoice-link',
  templateUrl: './nexus-invoice-link.component.html',
  styleUrls: ['./nexus-invoice-link.component.scss']
})
export class NexusInvoiceLinkComponent implements OnInit {
  @Input() public invoice_model: InvoiceModel;

  constructor() { }

  ngOnInit() {
    //console.log(this.invoice_model);
  }

}
